import { render, staticRenderFns } from "./ChatForm.vue?vue&type=template&id=17d01ca9&scoped=true"
import script from "./ChatForm.vue?vue&type=script&lang=js"
export * from "./ChatForm.vue?vue&type=script&lang=js"
import style0 from "./ChatForm.vue?vue&type=style&index=0&id=17d01ca9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d01ca9",
  null
  
)

export default component.exports